module.exports = "img/photo20.b6467d.jpeg";